<template>
  <div>
    <template v-if="crew.active == 1 || isSystemAdmin">
      <button
          class="btn btn-sm btn-outline-primary font-weight-bolder my-auto"
          data-toggle="modal"
          data-target="#add-crew-medical"
      >
        <span class="fas fa-file-medical"></span>
        Add Rapid/PCR Test
      </button>
    </template>

    <!-- ADD Document Modal -->
    <div
        class="modal fade px-2"
        id="add-crew-medical"
        tabindex="-1"
        role="dialog"
        aria-labelledby="add-crew-medical-title"
        aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-xxl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="add-crew-medical-title font-weight-bolder">
              Add New Medical Record
            </h5>
            <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
                id="close-add-crew-medical"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-small">
            <div class="row">
              <div class="col-sm-4">
                <form
                    class="form-group"
                    @submit.prevent="createCrewPcrRapidTest"
                >
                  <table class="col-table-2 table-sm w-100">
                    <tr>
                      <th>
                        <label
                            class="font-weight-bolder text-left form-label-sm"
                            for="test_type"
                        >
                          Test Type:
                        </label>
                      </th>
                      <td>
                        <select
                            id="test_type"
                            required
                            class="form-control form-control-sm"
                            v-model="pcrRapidTest.crew_covid_test_type_id"
                            @change="
                            setCrewCovidTestTypeResult(
                              pcrRapidTest.crew_covid_test_type_id
                            )
                          "
                        >
                          <option :value="''" disabled
                          >--- Select Test Type ---
                          </option
                          >
                          <option
                              v-for="covidTestType in covidTestTypes"
                              :key="covidTestType.id"
                              :value="covidTestType.id"
                          >{{ covidTestType.name }}
                          </option
                          >
                        </select>
                      </td>
                    </tr>

                    <tr>
                      <th>
                        <label
                            class="font-weight-bolder text-left form-label-sm"
                            for="conducted_place"
                        >
                          Place Conducted:
                        </label>
                      </th>
                      <td>
                        <select
                            class="form-control form-control-sm"
                            id="conducted_place"
                            v-model="
                            pcrRapidTest.crew_covid_test_conducted_place_id
                          "
                            @change="
                            clearHospitalLab();
                            toggleCrewPcrRapidOtherHospital();
                          "
                        >
                          <option :value="''"
                          >--- Select Place Conducted ---
                          </option
                          >
                          <option
                              v-for="conductedPlace in conductedPlaces"
                              :key="conductedPlace.id"
                              :value="conductedPlace.id"
                          >{{ conductedPlace.name }}
                          </option
                          >
                        </select>
                      </td>
                    </tr>

                    <tr>
                      <th>
                        <label
                            class="font-weight-bolder text-left form-label-sm"
                            for="country"
                        >
                          Country/Airport/Port/Vessel:
                        </label>
                      </th>
                      <td>
                        <select
                            class="form-control form-control-sm"
                            v-show="
                            !pcrRapidTest.crew_covid_test_conducted_place_id
                          "
                            :disabled="
                            !pcrRapidTest.crew_covid_test_conducted_place_id
                          "
                            name=""
                            id=""
                        ></select>

                        <select
                            v-if="
                            pcrRapidTest.crew_covid_test_conducted_place_id ===
                              1
                          "
                            class="form-control form-control-sm"
                            id="country"
                            v-model="pcrRapidTest.crew_covid_test_country_id"
                            @change="
                            fetchCrewCovidCountryHospitals(
                              pcrRapidTest.crew_covid_test_country_id
                            );
                            toggleCrewPcrRapidOtherHospital();
                          "
                        >
                          <option :value="''">--- Select Country ---</option>
                          <option
                              v-for="country in countries"
                              :key="country.id"
                              :value="country.id"
                          >{{ country.name }}
                          </option
                          >
                        </select>

                        <select
                            v-if="
                            pcrRapidTest.crew_covid_test_conducted_place_id ===
                              2 ||
                              pcrRapidTest.crew_covid_test_conducted_place_id ===
                                4
                          "
                            class="form-control form-control-sm"
                            id="country"
                            v-model="pcrRapidTest.port_id"
                            @change="
                            fetchCrewCovidCountryHospitals(
                              pcrRapidTest.crew_covid_test_country_id
                            )
                          "
                        >
                          <option :value="''">--- Select Port ---</option>
                          <option
                              v-for="ports in ports"
                              :key="ports.id"
                              :value="ports.id"
                              class="text-uppercase"
                          >{{ ports.name }}
                          </option
                          >
                        </select>

                        <input
                            type="text"
                            name=""
                            id="country"
                            v-if="
                            pcrRapidTest.crew_covid_test_conducted_place_id ===
                              3
                          "
                            class="form-control form-control-sm"
                            :value="currentCrewActivity.name"
                            readonly
                        />
                      </td>
                    </tr>

                    <tr>
                      <th>
                        <label
                            class="font-weight-bolder text-left form-label-sm"
                            for="hospital"
                        >
                          Hospital/Lab:
                        </label>
                      </th>
                      <td>
                        <input
                            v-if="!isCrewPcrRapidTestHospitalRequired"
                            id="date_result"
                            class="form-control form-control-sm"
                            type="text"
                            readonly
                            disabled
                        />

                        <select
                            v-else
                            :disabled="
                            pcrRapidTest.crew_covid_test_conducted_place_id != 1
                          "
                            class="form-control form-control-sm"
                            id="hospital"
                            v-model="
                            pcrRapidTest.crew_covid_test_country_hospital_id
                          "
                        >
                          <option :value="''"
                          >--- Select Hospital/Lab ---
                          </option
                          >
                          <option
                              v-for="countryHospital in countryHospitals"
                              :key="countryHospital.id"
                              :value="countryHospital.id"
                          >{{ countryHospital.name }}
                          </option
                          >
                        </select>
                      </td>
                    </tr>

                    <tr>
                      <th>
                        <label
                            class="font-weight-bolder text-left form-label-sm"
                            for="others"
                        >
                          Other Hospital/Lab:
                        </label>
                      </th>
                      <td>
                        <input
                            v-if="pcrRapidTest.crew_covid_test_country_hospital_id && countryHospitals"
                            id="date_result"
                            class="form-control form-control-sm"
                            type="text"
                            readonly
                            disabled
                        />

                        <input
                            v-else
                            type="text"
                            id="others"
                            class="form-control form-control-sm"
                            v-model="pcrRapidTest.others"
                        />
                      </td>
                    </tr>

                    <tr>
                      <th>
                        <label
                            class="font-weight-bolder text-left form-label-sm"
                            for="date_conducted"
                        >
                          Date Conducted:
                        </label>
                      </th>
                      <td>
                        <input
                            type="date"
                            id="date_conducted"
                            class="form-control form-control-sm"
                            v-model="pcrRapidTest.conducted_date"
                        />
                      </td>
                    </tr>

                    <tr>
                      <th>
                        <label
                            class="font-weight-bolder text-left form-label-sm"
                            for="date_result"
                        >
                          Date Result:
                        </label>
                      </th>
                      <td>
                        <input
                            type="date"
                            id="date_result"
                            class="form-control form-control-sm"
                            v-model="pcrRapidTest.result_date"
                        />
                      </td>
                    </tr>

                    <tr>
                      <th>
                        <label
                            class="font-weight-bolder text-left form-label-sm"
                            for="result"
                        >
                          Result:
                        </label>
                      </th>
                      <td>
                        <select
                            id="result"
                            class="form-control form-control-sm"
                            v-model="pcrRapidTest.crew_covid_test_type_result_id"
                        >
                          <option :value="''">--- Select Result ---</option>
                          <option
                              v-for="covidTestTypeResult in covidTestTypeResults"
                              :key="covidTestTypeResult.id"
                              :value="covidTestTypeResult.id"
                          >{{ covidTestTypeResult.name }}
                          </option
                          >
                        </select>
                      </td>
                    </tr>

                    <tr>
                      <th>
                        <label
                            class="font-weight-bolder text-left form-label-sm"
                            for="attachment"
                        >
                          Upload File:
                        </label>
                      </th>
                      <td>
                        <div class="custom-file">
                          <div id="crewMedicalContainer">
                            <input
                                type="file"
                                class="custom-file-input"
                                id="attachment"
                                accept="application/pdf"
                                @change="updateFileFrame"
                            />
                          </div>
                          <label class="custom-file-label" for="attachment"
                          >Choose file</label
                          >
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td></td>
                      <td class="text-right">
                        <button
                            type="button"
                            class="btn btn-secondary btn-sm mr-3"
                            data-dismiss="modal"
                        >
                          <i class="fas fa-times"></i>
                          Close
                        </button>
                        <button type="submit" class="btn btn-primary btn-sm">
                          <i class="fas fa-save"></i>
                          Save changes
                        </button>
                      </td>
                    </tr>
                  </table>
                </form>
              </div>
              <div class="col-sm-6 pb-8">
                <iframe
                    frameborder="0"
                    height="600"
                    width="950"
                    id="newFileFrame"
                    v-if="withUploadedFile"
                ></iframe>
                <div
                    class="alert alert-warning"
                    role="alert"
                    id="prompt-alert"
                    v-else
                >
                  NO UPLOADED DOCUMENT
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import {vueAppMixin} from "@/mixins/vueAppMixin";
import {vesselMixin} from "@/mixins/vesselMixin";
import {GlobalService} from "@/services/GlobalService";
import {gateMixin} from "@/mixins/gateMixin";
import Swal from "sweetalert2";
import {formMixin} from "@/mixins/formMixin";

export default {
  name: "AddPcrRapidTest",

  mixins: [gateMixin],

  data() {
    return {
      pcrRapidTest: {
        id: null,
        crew_id: null,
        crew_covid_test_type_id: null,
        crew_covid_test_conducted_place_id: null,
        crew_covid_test_type_result_id: null,
        conducted_date: null,
        result_date: null,
        crew_covid_test_country_hospital_id: null,
        crew_covid_test_country_id: null,
        port_id: null,
        others: null,
      },
      isCrewPcrRapidTestHospitalRequired: false,
      withUploadedFile: false,
    };
  },

  methods: {
    ...mapActions(["getPortKeys"]),

    async createCrewPcrRapidTest() {
      let formData = new FormData();

      Object.keys(this.pcrRapidTest).forEach((key) => {
        if (key === "test_type") {
          let value = this.pcrRapidTest[key] === "pcr" ? 1 : 0;
          formData.append("is_pcr", value);
        } else {
          let value = this.pcrRapidTest[key] ? this.pcrRapidTest[key] : "";
          formData.append(key, value);
        }
      });

      let attachment = document.getElementById("attachment");

      if (attachment.files && attachment.files[0]) {
        let file = attachment.files[0];
        formData.append("attachment", file);
      }
      formData.append("crew_id", this.crew.id);

      this.$store
          .dispatch("CrewCovidTestModule/createCrewPcrRapidTest", formData)
          .then(() => {
            Swal.fire({
              title: "Upload",
              text: "Crew PCR/Rapid Test Successfully Added.",
              type: "success",
              timer: 2000,
            });

            this.$store.dispatch(
                "CrewCovidTestModule/fetchCrewPcrRapidTests",
                this.crew.id
            );
            document.getElementById("attachment").value=null;
            document.getElementById("close-add-crew-medical").click();
          })
          .catch(error => {
            return GlobalService.handleError(error, 'createCrewPcrRapidTest');
          });
    },

    updateFileFrame() {
      let input = document.getElementById("attachment");
      if (input.files && input.files[0]) {
        if (input.files[0].size > 1000000) {
          document.getElementById("prompt-alert").innerText = "FILE TOO LARGE";
          this.clearIframe();
          this.withUploadedFile = false;
          return;
        } else {
          document.getElementById("prompt-alert").innerText = "";
          let reader = new FileReader();
          reader.onload = function (e) {
            document.getElementById("newFileFrame").src =
                e.target.result + "#zoom=80";
          };
          reader.readAsDataURL(input.files[0]);
          this.withUploadedFile = true;
        }
      }
    },

    clearIframe() {
      document.getElementById("newFileFrame").src = "";
    },

    async fetchConductedPlaces() {
      this.$store.dispatch(
          "CrewCovidTestConductedPlaceModule/fetchConductedPlaces"
      );
    },

    setCrewCovidTestTypeResult(crewCovidTestType) {
      this.$store.dispatch(
          "CrewCovidTestTypeResultModule/fetchTypeResults",
          crewCovidTestType
      );
    },

    fetchCrewCovidCountryHospitals(countryId) {
      this.$store.dispatch(
          "CrewCovidTestCountryHospitalModule/fetchCountryHospitals",
          countryId
      );
      this.pcrRapidTest.crew_covid_test_country_hospital_id = null;
    },

    clearHospitalLab() {
      if (this.pcrRapidTest.crew_covid_test_country_id !== 1) {
        this.pcrRapidTest.crew_covid_test_country_hospital_id = null;
      }
    },

    toggleCrewPcrRapidOtherHospital() {
      let country = this.countries.find(
          (country) =>
              country["id"] == this.pcrRapidTest.crew_covid_test_country_id
      );

      if (!country) {
        return;
      }

      this.isCrewPcrRapidTestHospitalRequired = country["is_hospital_required"];
    },
  },

  computed: {
    ...mapState({
      crew: (state) => {
        return state.CrewModule.crew;
      },

      conductedPlaces: (state) => {
        return state.CrewCovidTestConductedPlaceModule.conductedPlaces;
      },

      covidTestTypes: (state) => {
        return state.CrewCovidTestTypeModule.types;
      },

      covidTestTypeResults: (state) => {
        return state.CrewCovidTestTypeResultModule.typeResults;
      },

      countries: (state) => {
        return state.CrewCovidTestCountryModule.countries;
      },

      countryHospitals: (state) => {
        return state.CrewCovidTestCountryHospitalModule.countryHospitals;
      },

      ports: (state) => {
        return state.PortModule.portKeys;
      },

      currentCrewActivity: (state) => {
        return state.CurrentCrewActivityModule.currentCrewActivity;
      },
    }),
  },

  created() {
    this.fetchConductedPlaces();

    if (!this.ports.length) {
      this.getPortKeys();
    }
  },
  watch:{
    'pcrRapidTest.crew_covid_test_country_hospital_id'(){
      if(this.pcrRapidTest.crew_covid_test_country_hospital_id){
        this.pcrRapidTest.others=null;
      }
    }
  }
};
</script>

<style scoped></style>

